import { render, staticRenderFns } from "./Salon.vue?vue&type=template&id=5dce314e"
import script from "./Salon.vue?vue&type=script&lang=js"
export * from "./Salon.vue?vue&type=script&lang=js"
import style0 from "./Salon.vue?vue&type=style&index=0&id=5dce314e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports